import configData from "../config/config.json";

export const postUserStat = async(authHeaderValue, username, pageName, element, workbook, dashboard, exportType='', detail='') => {
    try{
        const url = configData.CCBHTableauAPIServer + "/stat";
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Authorization':authHeaderValue,
                      'Content-Type': 'application/json',
                      'Access-Control-Allow-Origin':'*'
                      },
            body:JSON.stringify({
                    "username": username,
                    "elementName": element,
                    "detail": detail,
                    "elementLabel": element,
                    "pageName":pageName,
                    "workbookName": workbook,
                    "dashboardName":dashboard,
                    "exportType": exportType
                }),
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    } 
};

export const addStat = async(authHeaderValue, username, elementName, detail) => {
    return await postUserStat(authHeaderValue, username, elementName, detail);
};
